import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import styles from '../../../style.js';
import MenuItem from '@mui/material/MenuItem';
import PhoneInput from 'react-phone-input-2'

class MobileInfoDialog extends React.Component {
  state = {
    open: false
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.props.onClose();
  };
  handleApprove = () => {
    this.props.handleApprove();
  };

  render() {
    const { operatorType,operatorTypesList,phoneNumber } = this.props;

    return (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={"sm"}
          open={this.props.open}
          onClose={this.handleClose}
        >
          <DialogTitle id="responsive-dialog-title"><h5>İmzayı Gerçekleştirecek Telefon Bilgileri</h5></DialogTitle>
          <DialogContent>
            <InputLabel id="operatorLbl" style={styles.label}>Operator</InputLabel>
            <Select
              className='customSelect'
              fullWidth
              labelId="operatorTypeLbl"
              id="operatorTypeId"
              value={operatorType}
              name="operatorType"
              style={styles.selectField}
              onChange={this.props.handleChange}>
              {operatorTypesList.map((item) => (
                <MenuItem value={item.parameterValue}>
                  <div style={styles.selectField}>{item.parameterName}</div>
                </MenuItem>
              ))}
            </Select>
            <InputLabel id="phoneLbl" style={styles.label}>Telefon</InputLabel>
            <PhoneInput inputProps={{id: "phoneNumberId",required: true,name:"phoneNumber"}} country={'tr'} style={styles.textField} disableDropdown countryCodeEditable = {false} value={phoneNumber} onBlur={this.props.handleChange}/>  
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              İptal
            </Button>
            <Button onClick={this.handleApprove} color="primary" autoFocus>
              Tamam
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

MobileInfoDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired
};

export default withMobileDialog()(MobileInfoDialog);
